import React, { forwardRef } from 'react';

import { Icon, Tooltip } from '@chakra-ui/react';
import {
  ChatCircleDots,
  EnvelopeSimple,
  MicrosoftTeamsLogo,
  Notification,
  Phone,
  SlackLogo,
  WhatsappLogo,
} from '@phosphor-icons/react';
import PropTypes from 'prop-types';
import { BiLogoMicrosoftTeams, BiSolidNotification } from 'react-icons/bi';
import { BsFillTelephoneFill, BsSlack, BsWhatsapp } from 'react-icons/bs';
import { IoChatbubbleEllipsesSharp, IoMail } from 'react-icons/io5';

const icons = {
  email: [
    'Email',
    <Icon
      as={EnvelopeSimple}
      boxSize="14px"
      color="content.tertiary"
      key="email"
    />,
  ],
  slack: [
    'Slack',
    <Icon as={SlackLogo} boxSize="14px" color="content.tertiary" key="slack" />,
  ],
  sms: [
    'SMS',
    <Icon
      as={ChatCircleDots}
      boxSize="14px"
      color="content.tertiary"
      key="sms"
    />,
  ],
  voice: [
    'Voice',
    <Icon as={Phone} boxSize="14px" color="content.tertiary" key="voice" />,
  ],
  apns: [
    'Push',
    <Icon
      as={Notification}
      boxSize="14px"
      color="content.tertiary"
      key="apns"
    />,
  ],
  fcm: [
    'Push',
    <Icon
      as={Notification}
      boxSize="14px"
      color="content.tertiary"
      key="fcm"
    />,
  ],
  whats_app: [
    'WhatsApp',
    <Icon
      as={WhatsappLogo}
      boxSize="14px"
      color="content.tertiary"
      key="whats_app"
    />,
  ],
  microsoft_teams: [
    'Microsoft Teams',
    <Icon
      as={MicrosoftTeamsLogo}
      boxSize="14px"
      color="content.tertiary"
      key="microsoft_teams"
    />,
  ],
};

export const NotificationIcon = ({ type }) => {
  const [tooltipText, icon] = icons[type];

  if (!icon) return null;

  const SpecificIcon = forwardRef(({ children, ...rest }, ref) => (
    <span ref={ref} {...rest}>
      {children}
    </span>
  ));

  SpecificIcon.displayName = 'SpecificIcon';

  return (
    <Tooltip placement="top" hasArrow label={tooltipText}>
      <SpecificIcon>{icon}</SpecificIcon>
    </Tooltip>
  );
};

NotificationIcon.propTypes = {
  type: PropTypes.string.isRequired,
};
